module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Marian Babson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Marian Babson, born Ruth Stenstreem, is an American mystery writer. Her first published work was "), _c('I', [_vm._v("Cover-Up Story")]), _vm._v(" (1971), and she has written over forty-five mysteries. Babson served as secretary of the Crime Writers’ Association and was awarded the CWA Dagger in the Library in 1996."), _c('BR'), _vm._v("  ")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/E5EP7k/tc-custom/9781504059800.jpg?1706728662431",
      "alt": "This image is the cover for the book Cat Who Wasn't a Dog, The Trixie Dolan & Evangeline Sinclair Mysteries"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Cat Who Wasn't a Dog, The Trixie Dolan & Evangeline Sinclair Mysteries\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A rescued cat is a clue to a killer’s identity in this cozy mystery by an “utterly entertaining” Agatha Award–winning author ("), _c('i', [_vm._v("Booklist")]), _vm._v(").")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Aging actress Dame Cecile Savoy is on the way to a Brighton taxidermist’s shop, accompanied by her friends Trixie and Evangeline—and her recently departed Pekingese. But when they arrive, they discover a dead body, a spreading fire, and a helpless Japanese bobtail cat in a cage."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" After rescuing the endangered kitty, aka Cho-Cho-San, Trixie and Evangeline now have another heroic task to attempt: finding out who’s responsible, and what sort of person would bring a live cat to a place like that."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “Ailurophiles will want to snuggle up to British veteran Marian Babson’s latest comic feline cozy.” —"), _c('i', [_vm._v("Publishers Weekly")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" The Cat Who Wasn’t a Dog "), _c('i', [_vm._v("is the 6th book in the Trixie Dolan & Evangeline Sinclair Mysteries, but you may enjoy reading the series in any order.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Integrated Media, Inc.\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0